import { HttpClient } from '@angular/common/http';
import { Observable,  BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { environment } from '../../../../../../../environments/environment';
import { HttpUtilsService } from '../../../../../../core/_base/crud/utils/http-utils.service';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { KhuVucKhoSumary, KhuVucKho } from '../so-do-kho-model/so-do-kho.model';

const API_ROOT_URL = environment.ApiRoot + '/kho';

@Injectable()
export class SoDoKhoService {
	
	lastFilter$: BehaviorSubject<QueryParamsModel> = new BehaviorSubject(new QueryParamsModel({}, 'asc', '', 0, 10));
	lastFilterDSExcel$: BehaviorSubject<any[]> = new BehaviorSubject([]);
	lastFilterInfoExcel$: BehaviorSubject<any> = new BehaviorSubject(undefined);
	lastFileUpload$: BehaviorSubject<{}> = new BehaviorSubject({});
	data_import:  BehaviorSubject<any[]> = new BehaviorSubject([]);
	ReadOnlyControl: boolean;

	constructor(private http: HttpClient,
	private httpUtils: HttpUtilsService) { }

	/*Get list data */
	getData(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/DNNK_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	getDataHHVTK(queryParams: QueryParamsModel): Observable<QueryResultsModel>{
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		const httpParams = this.httpUtils.getFindHTTPParams(queryParams);
		return this.http.get<any>(API_ROOT_URL + '/HH_VTK_List', {
			headers: httpHeaders,
			params: httpParams
		});
	}

	saveSoDoKho(item: KhuVucKhoSumary): Observable<any>{
		const httpHeaders = this.httpUtils.getHTTPHeaders(false);
		return this.http.post<any>(API_ROOT_URL+'/SDK_Insert', item, { headers: httpHeaders });
	}

	loadDataKV(id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhuVucKho>(API_ROOT_URL+`/SDK_GetList?IdKho=${id}`, { headers: httpHeaders });
	}

	loadDataConfigVTK(id: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<KhuVucKho>(API_ROOT_URL+`/SDK_GetListConfigVTK?IdKho=${id}`, { headers: httpHeaders });
	}

	getTTHangKho(id: number, cot: number, hang: number): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+ `/SDK_GetListState?IdKho=${id}` + `&&cot=${cot}`+ `&&hang=${hang}`, { headers: httpHeaders });
	}

	getNumOfQRPallet(): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+ `/get_current_number_pallet`, { headers: httpHeaders });
	}
	setNumOfQRPallet(newNum: string): Observable<any> {
		const httpHeaders = this.httpUtils.getHTTPHeaders();
		return this.http.get<any>(API_ROOT_URL+ `/update_current_number_pallet?newNum=${newNum}`, { headers: httpHeaders });
	}
}
